define(function(require) {
  const ViewManager = require('civicsUtils/view_manager');

  return {
    isProviderEnabled: function(productFamily){
      var globalConfig = ViewManager.globalConfig();

      var enabledProviders = globalConfig.get('attachments').get('enabledProviders');

      var isProviderEnabled = enabledProviders.includes(this.getCatalog(productFamily));

      return isProviderEnabled;
    },
    getCatalog: function(productFamily) {
      var catalog;

      var globalConfig = ViewManager.globalConfig();

      switch (productFamily.toUpperCase()) {
        case "SERVICEREQUEST":
          catalog = globalConfig.get("attachments").get("crmCatalog");
          break;
        case "BUILDING":
          catalog = globalConfig.get("attachments").get("buildingCatalog");
          break;
        case "BUSINESSLICENSE":
          catalog = globalConfig.get("attachments").get("licenseCatalog");
          break;
        case "CODEENFORCEMENT":
          catalog = globalConfig.get("attachments").get("caseCatalog");
          break;
        case "PLANNING":
          catalog = globalConfig.get("attachments").get("planningCatalog");
          break;
        case "PROJECT":
          catalog = globalConfig.get("attachments").get("projectCatalog");
          break;
        case "TRADELICENSE":
          catalog = globalConfig.get("attachments").get("tradeCatalog");
          break;
        case "USE":
          catalog = globalConfig.get("attachments").get("useCatalog");
          break;
        default:
          catalog = globalConfig.get("attachments").get("defaultCatalog");
      }

      // If the product specific catalog is not set, use the default
      if (!catalog || catalog.length == 0) {
        catalog = globalConfig.get("attachments").get("defaultCatalog");
      }
      return catalog;
    },

  };
});
